

















import { Component, Vue } from "vue-property-decorator";

@Component
class FPinConfirmDialog extends Vue {
  dialog = false;

  onConfirm: Function | null = null;

  onCancel: Function | null = null;

  mounted() {
    this.$root.$on(
      this.$rootEvents.PIN_ENTER,
      (onConfirm = null, onCancel = null) => {
        this.onConfirm = onConfirm;
        this.onCancel = onCancel;
        setTimeout(() => {
          this.dialog = true;
        }, 1000);
      }
    );
  }

  handleCancel() {
    this.dialog = false;
    if (this.onCancel) {
      this.onCancel();
    }
  }

  handleConfirm() {
    this.dialog = false;
    if (this.onConfirm) {
      this.onConfirm();
    }
  }
}
export default FPinConfirmDialog;
